module.exports = __webpack_public_path__ + "img/el-ic-wechatpay.3335abc3.svg";